<template>
	<div v-bind:class="getMainClass()" v-bind:style="getMainStyle()" v-bind:id="getMainId()">
		<div v-if="loading" class="loading d-flex">
			<div class="loading-dots justify-content-center align-self-center">
				<div class="dot"></div>
				<div class="dot"></div>
				<div class="dot"></div>
			</div>
		</div>
		<slot></slot>

		<div v-if="!noScrollFix" class="overflow-fix-container">
         <div class="overflow-fix"></div>
     	</div>

	</div>
</template>

<script>
export default {
	computed: {
		deviceType:function(){
			return this.$store.state.device.type;
		},
		marginTop:function(){
			return this.$store.state.scroll.marginTop;
		}
	},
	methods:{
		getMainClass:function(){
			if (this.deviceType !== 'mobile'){
				return 'd-flex flex-column col-md-6 col-lg-5 col-xl-4 left-col-full h-100 position-relative p-0';
			}
			return 'content-mobile col left-col-full position-relative p-0';
		},
		getMainId:function(){
			return this.mainId || '';
		},
		getMainStyle:function(){
			if (this.deviceType !== 'mobile' || this.noMt) return '';
			return 'margin-top:'+this.marginTop+'px;';
		}
	},
	props:{
		loading:{
			type:Boolean
		},
		mainId:{
			type:String
		},
		noMt:{
			type:Boolean
		},
		noScrollFix:{
			type:Boolean
		}
	}
}
</script>

<style>
	.content-mobile{
		width:100%;z-index:1010;
	}
	.mobile .overflow-fix-container{
		position:fixed;
		bottom:0;
		left:0;
		right:0;
	}
	.mobile .overflow-fix{
		background-color:#37474F;
		height:120px;
		width:100%;
	}
	.loading{
		z-index:1011;
	}
</style>


// WEBPACK FOOTER //
// src/components/content/index.vue